import React from "react";
import { Button } from "semantic-ui-react";
import PSMIOPSM1_MAIN from "./PSMIOPSM1_MAIN";
import PSMIOPSM2_MAIN from "./PSMIOPSM2_MAIN";
import PSMIOPSM3_MAIN from "./PSMIOPSM3_MAIN";
import PSMIOPSM4_MAIN from "./PSMIOPSM4_MAIN";
import PSMIOPSM5_MAIN from "./PSMIOPSM5_MAIN";

const PSMIO_MAIN = () => {
  const [toggleButton, setToggleButton] = React.useState("1");

  const handleClick = (e, { id }) => {
    setToggleButton(id);
  };

  const renderSwitch = (param) => {
    switch (param) {
      case "1":
        return <PSMIOPSM1_MAIN />;
      case "2":
        return <PSMIOPSM2_MAIN />;
      case "3":
        return <PSMIOPSM3_MAIN />;
      case "4":
        return <PSMIOPSM4_MAIN />;
      case "5":
        return <PSMIOPSM5_MAIN />;

      default:
        return <PSMIOPSM1_MAIN />;
    }
  };

  return (
    <div style={styles.div}>
      <Button.Group toggle style={styles.toggle}>
        <Button
          size="medium"
          id="1"
          active={toggleButton === "1"}
          onClick={handleClick}
          content="PSM1 IO"
        />
        <Button
          size="medium"
          id="2"
          active={toggleButton === "2"}
          onClick={handleClick}
          content="PSM2 IO"
        />
        <Button
          size="medium"
          id="3"
          active={toggleButton === "3"}
          onClick={handleClick}
          content="PSM3 IO"
        />
        <Button
          size="medium"
          id="4"
          active={toggleButton === "4"}
          onClick={handleClick}
          content="PSM4 IO"
        />
        <Button
          size="medium"
          id="5"
          active={toggleButton === "5"}
          onClick={handleClick}
          content="PSM5 IO"
        />
      </Button.Group>
      {renderSwitch(toggleButton)}
    </div>
  );
};

const styles = {
  div: {
    textAlign: "center",
  },
  toggle: {
    marginLeft: "8px",
  },
};

export default PSMIO_MAIN;
